import { useAppItems } from "./hooks/useItems";
import { ItemTable } from "./components/ItemTable";
import { ItemUploader } from "./components/ItemUpload";
import { Header } from "./components/Header";
import { ItemContainer } from "./components/ItemContainer";
import {
  NotificationContainer,
  ModalContainer,
  LoadingOverlay,
  DialogContainer,
  Button,
  useModals,
} from "./ui";
import { getContainerActions, setContainer, useContainer } from "./hooks/useContainer";
import { SimpleItemUpload } from "./features/itemUpload/components/SimpleItemUpload";
import { ItemUploadComponent } from "./features/itemUpload";

/**
 * Entry point to the app.
 */
function App() {
  const url = document.URL.match(/\?container=(?<url>.*$)/)?.groups!.url;
  const { setContainerUrl } = getContainerActions();
  if(url) {
    setContainerUrl(url);
  }

  const { items, removeItem } = useAppItems();
  const { open } = useModals();
  const { status } = useContainer();

  return (
    <div className="px-4 h-full bg-bg-primary min-h-screen transition-colors">
      <section className="max-w-xl m-auto relative">
        <Header />
        <ItemContainer />

        {status === "ready" && (
          <>
            <div className="flex justify-center">
              <Button
                className="mt-4 mb-6"
                onClick={() =>
                  open({
                    title: "Upload Item",
                    content: <ItemUploadComponent onUploadComplete={() => {
                
                    }} />, 
                    size: "lg",
                  })
                }
              >
                Upload Item
              </Button>
            </div>

            <ItemTable />
          </>
        )}
      </section>
      <NotificationContainer />
      <ModalContainer />
      <LoadingOverlay />
      <DialogContainer />
    </div>
  );
}

export default App;
